// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";
import "firebase/firestore";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
//import 'firebase/analytics';
const firebaseConfig = {
  apiKey: "AIzaSyDxUrYkw-OkVaXE0SFR4NBFhOY6Jv54BEs",
  authDomain: "odin-bf0c8.firebaseapp.com",
  databaseURL: "https://odin-bf0c8.firebaseio.com",
  projectId: "odin-bf0c8",
  storageBucket: "odin-bf0c8.appspot.com",
  messagingSenderId: "639978855710",
  appId: "1:639978855710:web:e8f66bab05ce680ce5bd0f",
  //measurementId: "GTM-K4N38N6"
};
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

const db = firebase.firestore();
db.settings({
  timestampsInSnapshots: true,
});
export const streamPosts = (amount, observer) => {
  return db
    .collection("posts")
    .orderBy("publishAt", "desc")
    .limit(amount)
    .onSnapshot(observer);
};

export const createPost = (data) => {
  data.publishAt = firebase.firestore.FieldValue.serverTimestamp();
  return db.collection("posts").add(data);
};

export const likePost = (postId, userName) => {
  const post = db.collection("posts").doc(postId);
  return post.update({
    likedBy: firebase.firestore.FieldValue.arrayUnion(userName),
  });
};

export const unlinePost = (postId, userName) => {
  const post = db.collection("posts").doc(postId);
  return post.update({
    likedBy: firebase.firestore.FieldValue.arrayRemove(userName),
  });
};

export const commentPost = (postId, comment) => {
  const post = db.collection("posts").doc(postId);
  return post.update({
    comments: firebase.firestore.FieldValue.arrayUnion({
      ...comment,
      createdAt: firebase.firestore.Timestamp.now(),
    }),
  });
};

export const streamEvents = (observer) => {
  return db
    .collection("events")
    .where("eventDate", ">", firebase.firestore.Timestamp.now())
    .orderBy("eventDate", "asc")
    .limit(5)
    .onSnapshot(observer);
};

export const eventRegister = (eventId, userName) => {
  const post = db.collection("events").doc(eventId);
  return post.update({
    participants: firebase.firestore.FieldValue.arrayUnion(userName),
  });
};
